/* Model */
class RouteHelperAssignmentModel extends App.Models.AssignUnassignToRoute {
    modelUrl = 'RouteHelperAssignment';
    urlAssignUnassign = "RouteHelper";
}

App.Models.RouteHelperAssignment = RouteHelperAssignmentModel;

/* Collection */
class RouteHelperAssignmentCollection extends App.Collections.BaseCollection {
    url = 'RouteHelperAssignment';
    model = App.Models.RouteHelperAssignment;
}

App.Collections.RouteHelperAssignments = RouteHelperAssignmentCollection;

/* Router */
class RouteHelperAssignmentRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'RouteHelperAssignment';
        const model = App.Models.RouteHelperAssignment;
        const collectionClass = App.Collections.RouteHelperAssignments;

        super(entityName, model, collectionClass);
    }
}

App.Routers.RouteHelperAssignment = RouteHelperAssignmentRouter;
